/* Help Center — client-side search over the rendered FAQ + active topic on scroll. */
(function () {
  function init() {
    var root = document.querySelector(".help-center");
    if (!root) return;
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";

    var input = root.querySelector("[data-help-search]");
    var items = Array.prototype.slice.call(
      root.querySelectorAll("[data-help-item]"),
    );
    var cats = Array.prototype.slice.call(
      root.querySelectorAll("[data-help-category]"),
    );
    var empty = root.querySelector("[data-help-empty]");
    var navLinks = Array.prototype.slice.call(
      root.querySelectorAll("[data-help-nav-link]"),
    );

    if (input) {
      input.addEventListener("input", function () {
        var q = input.value.trim().toLowerCase();
        var any = false;

        items.forEach(function (item) {
          var text = item.getAttribute("data-help-text") || "";
          var match = !q || text.indexOf(q) !== -1;
          item.hidden = !match;
          item.open = q ? match : false;
          if (match) any = true;
        });

        cats.forEach(function (cat) {
          cat.hidden = !cat.querySelector("[data-help-item]:not([hidden])");
        });

        if (empty) empty.hidden = !q || any;
      });
    }

    if (navLinks.length && "IntersectionObserver" in window) {
      var setActive = function (id) {
        navLinks.forEach(function (link) {
          link.classList.toggle(
            "is-active",
            link.getAttribute("data-help-nav-link") === id,
          );
        });
      };
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: "-15% 0px -75% 0px" },
      );
      cats.forEach(function (cat) {
        observer.observe(cat);
      });
    }

    // Deep-link: open + scroll to the article whose id matches the URL hash.
    // Widget FAQ links arrive here as /pages/help#q-<chatwoot-slug>.
    var openFromHash = function () {
      var id = decodeURIComponent(
        (window.location.hash || "").replace(/^#/, ""),
      );
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) {
        // A hand-built or blog-style link may use the clean title handle, which
        // is a prefix of the full slug used as the anchor id.
        var all = root.querySelectorAll('[id^="q-"]');
        for (var i = 0; i < all.length; i += 1) {
          if (all[i].id === id || all[i].id.indexOf(id + "-") === 0) {
            target = all[i];
            break;
          }
        }
      }
      if (!target) return;
      if (target.tagName === "DETAILS") target.open = true;
      var doScroll = function () {
        var header = document.querySelector(".section-header");
        var offset = (header ? header.offsetHeight : 0) + 16;
        window.scrollTo(
          0,
          target.getBoundingClientRect().top + window.pageYOffset - offset,
        );
      };
      // Instant + retried: a smooth scroll gets cancelled by scroll anchoring,
      // and a single scroll on load lands short before the page finishes
      // laying out. Re-apply over ~0.5s to settle on the right position.
      doScroll();
      setTimeout(doScroll, 120);
      setTimeout(doScroll, 450);
    };

    openFromHash();
    window.addEventListener("hashchange", openFromHash);
    // Re-run once the page is fully laid out — on initial load the content above
    // the target may not have its final height yet, so the first scroll lands short.
    window.addEventListener("load", openFromHash);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
